module.exports = __webpack_public_path__ + "media/images/new_home/food-2020d774ecc37501b78b467d4d580991.png";